import { PriceAmountType } from '../../constants/price-amount-type.js';
import { priceRuleAmountCellKey } from '../../pricing/price-rule-amount-cell-key.js';
import { isSet } from './is-set.js';
const DUPLICATE_AMOUNT_MESSAGE = 'Each amount must have a unique payment term, term group, and amount type.';
const TERM_AND_GROUP_MESSAGE = 'An amount cannot target both a payment term and a payment terms group.';
const LIST_TERM_AGNOSTIC_MESSAGE = 'List and MSRP prices do not vary by payment term.';
/** Validates only what a single differ call's array can check on its own -- no two rows
 *  addressing the same cell, no row targeting both a term and a group, no list/msrp row carrying
 *  a term or group -- since setPrice patches one or more cells at a time and a single call may
 *  legitimately omit the rule's wholesale fallback row it doesn't intend to touch. */
export function refinePriceRuleAmounts(value, ctx) {
    const firstIndexByKey = new Map();
    const flaggedIndexes = new Set();
    value.amounts.forEach((row, index) => {
        const paymentTermsId = isSet(row.paymentTermsId) ? row.paymentTermsId : null;
        const paymentTermsGroupId = row.paymentTermsGroupId ?? null;
        const key = priceRuleAmountCellKey({
            paymentTermsId,
            paymentTermsGroupId,
            amountTypeId: row.amountTypeId,
        });
        const firstIndex = firstIndexByKey.get(key);
        if (firstIndex === undefined) {
            firstIndexByKey.set(key, index);
        }
        else {
            const collidingField = paymentTermsId !== null
                ? 'paymentTermsId'
                : paymentTermsGroupId !== null
                    ? 'paymentTermsGroupId'
                    : 'amountTypeId';
            // Flag both rows -- the first occurrence looked fine on its own until this later row
            // collided with it, so leaving it unmarked would hide half of the conflict from the UI.
            for (const flagIndex of [firstIndex, index]) {
                if (flaggedIndexes.has(flagIndex))
                    continue;
                flaggedIndexes.add(flagIndex);
                ctx.addIssue({
                    code: 'custom',
                    message: DUPLICATE_AMOUNT_MESSAGE,
                    path: ['amounts', flagIndex, collidingField],
                });
            }
        }
        if (paymentTermsId !== null && paymentTermsGroupId !== null) {
            ctx.addIssue({
                code: 'custom',
                message: TERM_AND_GROUP_MESSAGE,
                path: ['amounts', index, 'paymentTermsGroupId'],
            });
        }
        if (row.amountTypeId !== PriceAmountType.WHOLESALE &&
            (paymentTermsId !== null || paymentTermsGroupId !== null)) {
            const offendingField = paymentTermsId !== null ? 'paymentTermsId' : 'paymentTermsGroupId';
            ctx.addIssue({
                code: 'custom',
                message: LIST_TERM_AGNOSTIC_MESSAGE,
                path: ['amounts', index, offendingField],
            });
        }
    });
}
//# sourceMappingURL=amounts-refine.js.map